module.exports = "/virtual-football/img/video/clubs/germany/bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/germany/bayern.png
// module id = 294
// module chunks = 6